import React from "react"
import strings from "../../localization/strings"
import { Paper, Menu, MenuItem, Toggle } from "material-ui"
import { EExceptionUITypes } from "../../models"
interface IProps {
	allFilterItems: EExceptionUITypes[]
	showFilterItems: EExceptionUITypes[]
	handleUpdateShowFilterItems(event, valud): void
}

const SelectShowFilterItemMenu: React.SFC<IProps> = (props: IProps) => {
	const getToggleMenuItemTitle = (item: EExceptionUITypes) => {
		switch (item) {
			case EExceptionUITypes.MissPunch:
				return strings.Missing_Punches
			case EExceptionUITypes.NoEmpApprove:
				return strings.Emp_Approval
			case EExceptionUITypes.NoSupApprove:
				return strings.Sup_Approval
			case EExceptionUITypes.BioException:
				return strings.Biometric
			case EExceptionUITypes.LocException:
				return strings.Location
			case EExceptionUITypes.ScheduleMissingInPunch:
				return strings.Missing_In_Punch
			case EExceptionUITypes.ScheduleEarlyInPunch:
				return strings.Early_In
			case EExceptionUITypes.ScheduleLateInPunch:
				return strings.Late_In
			case EExceptionUITypes.ScheduleEarlyOutPunch:
				return strings.Early_Out
			case EExceptionUITypes.ScheduleLateOutPunch:
				return strings.Late_Out
			case EExceptionUITypes.ScheduleMissingBreak:
				return strings.Missed_Break
			case EExceptionUITypes.ScheduleLongBreak:
				return strings.Long_Break
			case EExceptionUITypes.ScheduleNoShift:
				return strings.No_Shift
			case EExceptionUITypes.QuestionException:
				return strings.Question_Exception
			case EExceptionUITypes.Timeoff:
				return strings.Timeoff_Request
			case EExceptionUITypes.SuspensePunch:
				return strings.Suspense_Punch
			case EExceptionUITypes.TimeFraud:
				return strings.Time_Fraud
		}
	}
	return (
		<Paper style={{ position: "absolute", top: 30, right: 40, zIndex: 10 }}>
			<Menu style={{ textAlign: "left" }}>
				<MenuItem>
					<span style={{ fontWeight: "bold" }}>{strings.Exception_Filters}</span>
				</MenuItem>
				{props.allFilterItems.map((item, index) =>
					<MenuItem key={index} style={{ minHeight: 35 }}>
						<Toggle
							data-intercom-target={`ExceptionFilter-Toggle-${item}`}
							name={item}
							toggled={props.showFilterItems.indexOf(item) > -1}
							label={getToggleMenuItemTitle(item)}
							onToggle={props.handleUpdateShowFilterItems}
							labelStyle={{ fontSize: 14 }}
						/>
					</MenuItem>
				)}
			</Menu>
		</Paper>
	)
}

export default SelectShowFilterItemMenu